export const commonInitial = {
  rating: null,
  note: '',
  success: true,
}
